const numberFormatCache = new Map<string, Intl.NumberFormat>();

export const getCachedNumberFormatter = (
  options: Intl.NumberFormatOptions,
  locale: string = 'en-US',
) => {
  const key = `${locale}|${JSON.stringify(options)}`;

  if (!numberFormatCache.has(key)) {
    numberFormatCache.set(key, new Intl.NumberFormat(locale, options));
  }

  return numberFormatCache.get(key) as Intl.NumberFormat;
};
